// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-slide-slide-ewqZn {
  flex: 0 0 100%;
  min-width: 0px;
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 12px 20px 20px;
}

.onboarding-slide-content-VGWTj {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 480px;
  max-width: 100%;
  min-height: 100%;
  text-align: center;
  margin: 0px auto;
}

.onboarding-slide-iconContainer-nFptb {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background-color: var(--onboarding-accent-soft);
  border-radius: 50%;
}

.onboarding-slide-heroIcon-tGDp9 {
  --size: 36px;
  color: var(--onboarding-accent-color);
}

.onboarding-slide-title-GjuQJ {
  color: var(--color-neutral-900);
  font-size: var(--text-xl);
  font-weight: var(--font-weight-medium);
  line-height: 1.25;
  margin: 22px 0px 0px;
}

.onboarding-slide-description-yAa5a {
  color: var(--color-neutral-600);
  font-size: 15px;
  line-height: 1.5;
  margin: 12px 0px 0px;
}

@media (max-height: 700px) {
  .onboarding-slide-content-VGWTj {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/onboarding-slide/onboarding-slide.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".slide {\n  flex: 0 0 100%;\n  min-width: 0px;\n  height: 100%;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 12px 20px 20px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 480px;\n  max-width: 100%;\n  min-height: 100%;\n  text-align: center;\n  margin: 0px auto;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 60px;\n  height: 60px;\n  background-color: var(--onboarding-accent-soft);\n  border-radius: 50%;\n}\n\n.heroIcon {\n  --size: 36px;\n  color: var(--onboarding-accent-color);\n}\n\n.title {\n  color: var(--color-neutral-900);\n  font-size: var(--text-xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.25;\n  margin: 22px 0px 0px;\n}\n\n.description {\n  color: var(--color-neutral-600);\n  font-size: 15px;\n  line-height: 1.5;\n  margin: 12px 0px 0px;\n}\n\n@media (max-height: 700px) {\n  .content {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide": `onboarding-slide-slide-ewqZn`,
	"content": `onboarding-slide-content-VGWTj`,
	"iconContainer": `onboarding-slide-iconContainer-nFptb`,
	"heroIcon": `onboarding-slide-heroIcon-tGDp9`,
	"title": `onboarding-slide-title-GjuQJ`,
	"description": `onboarding-slide-description-yAa5a`
};
export default ___CSS_LOADER_EXPORT___;
